import "./LabAttachmentsViewComponent.scss";
import React, {useEffect, useState} from "react";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";

interface LabAttachmentsViewComponentProps {
    labAttachments: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LabAttachmentsViewComponent = (props: LabAttachmentsViewComponentProps) => {
    const {labAttachments, onEditModeOpen, canEdit} = props;
    const [labAttachmentsList, setLabAttachmentsList] = useState<any>(undefined);

    useEffect(() => {
        setLabAttachmentsList(labAttachments);
    }, [labAttachments]);

    return (
        <div className="lab-attachments-component details-tab-data-content">
            <>
                {labAttachmentsList?.length > 0 ?
                    <div className="d-flex justify-content-space-between">
                        <div>
                            {
                                labAttachmentsList?.length > 0 && <>
                                    <div className="details-tab-data-header">
                                        <div className="view-and-edit-title">Lab Attachments</div>
                                    </div>
                                    <div className='details-tab-data-body test-Order-view-attachments'>
                                        {labAttachmentsList?.map((labAttachment: any) => {
                                            return (
                                                <div key={labAttachment.id} className={labAttachment.title}>
                                                    <AttachmentViewDownloadComponent
                                                        attachment={labAttachment}
                                                        attachmentTitle={labAttachment.attachmentName}
                                                        showDeleteOption={false}
                                                        showDownloadOption={true}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </>
                            }
                        </div>
                        {canEdit &&
                            <div>
                                <ButtonComponent
                                    className={"white-space-nowrap"}
                                    type="button"
                                    color={"primary"}
                                    variant={"outlined"}
                                    startIcon={<EditIcon/>}
                                    fullWidth={true}
                                    handleClick={() => {
                                        onEditModeOpen()
                                    }}
                                >
                                    Edit Details
                                </ButtonComponent>
                            </div>
                        }
                    </div>
                    :
                    <div className="no-attachments-wrapper">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <div className='no-attachments-header'>
                                    No attachment have been uploaded
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {canEdit &&
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        handleClick={() => {
                                            onEditModeOpen()
                                        }}
                                    >
                                        Add Attachment
                                    </ButtonComponent>
                                }
                            </Grid>
                        </Grid>
                    </div>
                }
            </>
        </div>
    )


};

export default LabAttachmentsViewComponent;
